export const MESSAGE_ROLES = {
  System: 'system',
  Assistant: 'assistant',
  User: 'user',
};
